import Tresorf1 from '../../../Media/Fasilitas BSD/Tresor/Tresor (1).webp'
import Tresorf2 from '../../../Media/Fasilitas BSD/Tresor/Tresor (2).webp'
import Tresorf3 from '../../../Media/Fasilitas BSD/Tresor/Tresor (3).webp'
import Tresorf4 from '../../../Media/Fasilitas BSD/Tresor/Tresor (4).webp'




const Tresorfimages =[
Tresorf1,Tresorf2,Tresorf3,Tresorf4
]

export default Tresorfimages;